export enum CenteredSlideType {
  CustomComponent = 'customComponent',
  Image = 'image',
  CenteredText = 'centeredText',
  DoubleCenteredText = 'doubleCenteredText'
}
